import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { generateRowData } from 'Store/lists/utilities';
import { columnSizeByList } from 'Store/lists/constants';

import ListRow from 'Components/ListRow/ListRow';
import UsersListActions from 'Containers/UsersListActions';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

const UsersListRow = memo(({ data, columnIds, ...props }) => {
  const [pairs, setPairs] = useState([]);
  useEffect(() => {
    if (pairs.length === 0) {
      const row = generateRowData(columnIds, data);
      if (data && data.account_status === 'invited') {
        setPairs([
          {
            key: 'pending_name',
            value: (
              <ConnectedFormattedMessage id="users_list.placeholder_values.invited_teacher" />
            ),
          },
          { key: 'username', value: row.username },
        ]);
      }
      setPairs(columnIds.map(key => ({ key, value: row[key] })));
    }
  });

  const getActions = () => {
    const { groupType } = props;
    const actionsProps = {
      data,
      groupType,
      groupId: props.groupId,
      actions: ['edit'],
    };
    if (groupType === 'class')
      actionsProps.actions.push('removeStudentFromClass');
    if (data.account_status === 'invited' && data.isEducator) {
      actionsProps.actions = ['removeInvitedUser', 'resendInvite'];
    }
    return <UsersListActions {...actionsProps} />;
  };

  if (!props) return null;
  return (
    <ListRow
      data={pairs}
      status={
        data && data.account_status !== 'active' ? data.account_status : null
      }
      additionalClassNames={props.rowIndex % 2 ? ' ListRow--dark' : undefined}
      actions={getActions()}
      columnIds={columnIds}
      columnSizes={columnSizeByList(props.type)}
      {...props}
    />
  );
});

UsersListRow.propTypes = {
  data: PropTypes.object.isRequired,
  columnIds: PropTypes.array.isRequired,
  groupType: PropTypes.string,
  groupId: PropTypes.number,
  rowIndex: PropTypes.number,
};

export default UsersListRow;
